import { axios } from '.'


/**
 * Get HeadlessCms content
 *
 * @param {string} versionNumber version e.g. v1
 * @param {string} brandName Brand
 * @param {string} languageId fr
 * @returns returns AEM HeadlessCms content
 */
export function getCmsContent(versionNumber, brandName, languageId) {
  return axios
    .get(
      `/content-integration/${versionNumber}/${brandName}/${languageId}`,
      {
        validateStatus: statusCode => statusCode === 200,
      }
    )
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}


